import { Box, styled } from '@mui/material';

export const EmptyWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  width: 100%;
  height: 100%;
`;

const DEFAULT_EMPTY_ICON_WIDTH = 173;
const DEFAULT_EMPTY_ICON_HEIGHT = 151;

export const EmptyImg = styled('img')<{
  $imageWidth?: number;
  $imageHeight?: number;
}>(
  ({ $imageWidth, $imageHeight }) => `
  width: ${$imageWidth ?? DEFAULT_EMPTY_ICON_WIDTH}px;
  height: ${$imageHeight ?? DEFAULT_EMPTY_ICON_HEIGHT}px;
`,
);
